// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css or App.css */
/* @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap'); */

body {
  font-family: 'Poppins', sans-serif;
}

/* body { */
/* margin: 0;
  padding: 0;
body {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #bdd9f6; Set a background color for the page */
/* background-image: linear-gradient(
    to top right,
    rgb(0, 149, 255),
    rgb(105, 202, 255),
    rgb(232, 247, 255)
  ); */
/* font-family: "Nunito Sans" !important; */
/* } */

.background-image {
  position: fixed;
  top: 0;
  left: 200px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  z-index: -10; /* Place the image behind the content */
}

.background-image img {
  width: 50%;
  max-height: 100%;
  border-radius: 300px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* BUTTONS */

/* CSS */
.button-89 {
  --b: 4px; /* border thickness */
  --s: 0.5em; /* size of the corner */
  /* --color: #373b44; */
  --color: #333333;

  padding: calc(0.5em + var(--s)) calc(0.9em + var(--s));
  color: var(--color);
  --_p: var(--s);
  background: conic-gradient(
      from 90deg at var(--b) var(--b),
      #0000 90deg,
      var(--color) 0
    )
    var(--_p) var(--_p) / calc(100% - var(--b) - 2 * var(--_p))
    calc(100% - var(--b) - 2 * var(--_p));
  transition: 8s linear, color 0s, background-color 1s;
  outline: var(--b) solid #0000;
  outline-offset: 0.6em;
  font-size: 14px;

  border: 0;

  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-89:hover,
.button-89:focus-visible {
  --_p: 0px;
  outline-color: var(--color);
  outline-offset: 0.05em;
}

.button-89:active {
  background: var(--color);
  color: #fff;
}

/* END BUTTONS */

/* Calculator */

.calc-input::before {
  border: '3px solid red';
}

/* End Calculator */

/* Facts */

/* @charset "UTF-8"; */
.quote {
  width: 100%;
  /* display: inline-block; */
  display: 'flex';
  justify-content: 'center';
  align-items: 'center';
  align-content: 'center';
  margin: '1rem';
  overflow: hidden;
}
.quote blockquote {
  width: 100%;
  height: 155px;
  background-color: #fafafa;
  border: solid 2px #42a5f5;
  border-radius: 4px;
  /* display: "flex";
  justify-content: "center";
  align-items: "center";
  align-content: "center"; */
  margin: 0;
  padding: 1em;
  position: relative;
}
.quote blockquote:before {
  background-color: #fff;
  bottom: -10%;
  content: '';
  left: 0;
  position: absolute;
  right: 0;
  top: -10%;
  transform: rotate(-15deg) skew(5deg);
}
.quote blockquote cite {
  display: block;
  font-style: italic;
  text-align: right;
}
.quote blockquote cite:before {
  content: '- ';
}
.quote blockquote > * {
  position: relative;
  z-index: 1;
}

.animated-border-quote {
  display: inline-block;
  margin: 1em;
  max-width: 20em;
  overflow: hidden;
}
.animated-border-quote blockquote {
  background-color: #fff;
  border: solid 2px #757575;
  border-radius: 5px;
  display: inline-block;
  margin: 0;
  padding: 1em;
  position: relative;
}
.animated-border-quote blockquote:before {
  animation: clockwise 30s infinite linear;
  background-color: #fff;
  bottom: 10%;
  content: '';
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 10%;
}
.animated-border-quote blockquote:after {
  animation: counter 30s infinite linear;
  background-color: #fff;
  bottom: 10%;
  content: '';
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 10%;
}
.animated-border-quote blockquote cite {
  display: block;
  font-style: italic;
  text-align: right;
}
.animated-border-quote blockquote cite:before {
  content: '- ';
}
.animated-border-quote blockquote > * {
  position: relative;
  z-index: 1;
}

@keyframes clockwise {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes counter {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.animated-shadow-quote {
  display: inline-block;
  margin: 1em;
  max-width: 20em;
  position: relative;
}
.animated-shadow-quote blockquote {
  animation: shadows 2s linear infinite alternate;
  display: inline-block;
  margin: 0;
  padding: 1em;
}
.animated-shadow-quote blockquote cite {
  display: block;
  font-style: italic;
  text-align: right;
}
.animated-shadow-quote blockquote cite:before {
  content: '- ';
}

@keyframes shadows {
  0% {
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.25);
    transform: scale(0.95);
  }
  100% {
    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.25);
    transform: scale(1);
  }
}
.square-brackets-quote {
  display: inline-block;
  font-family: sans-serif;
  margin: 1em;
  max-width: 20em;
}
.square-brackets-quote blockquote {
  border: solid 1em #ccc;
  border-radius: 5px;
  display: inline-block;
  margin: 0;
  padding: 1em;
  position: relative;
}
.square-brackets-quote blockquote:before {
  background-color: #fff;
  bottom: -1em;
  content: '';
  left: 2em;
  position: absolute;
  right: 2em;
  top: -1em;
}
.square-brackets-quote blockquote cite {
  color: #757575;
  display: block;
  font-size: small;
  font-style: normal;
  text-align: right;
  text-transform: uppercase;
}
.square-brackets-quote blockquote > * {
  position: relative;
  z-index: 1;
}

.giant-quotes-quote {
  display: inline-block;
  font-family: sans-serif;
  margin: 1em;
  max-width: 20em;
}
.giant-quotes-quote blockquote {
  display: inline-block;
  margin: 0;
  padding: 1em;
  position: relative;
}
.giant-quotes-quote blockquote:before {
  color: #f90;
  content: '“';
  font-size: 4em;
  left: 0;
  line-height: 0.75em;
  position: absolute;
  top: 0;
  transform: scale(2, 8);
  transform-origin: top;
}
.giant-quotes-quote blockquote:after {
  color: #f90;
  content: '”';
  font-size: 4em;
  line-height: 0.75em;
  position: absolute;
  right: 0;
  top: 0;
  transform: scale(2, 8);
  transform-origin: top;
}
.giant-quotes-quote blockquote > * {
  padding: 0 2em;
}
.giant-quotes-quote blockquote cite {
  color: #c60;
  display: block;
  font-style: normal;
  text-align: right;
  text-transform: uppercase;
}

/* End Facts */

/* Bio */

.test::after {
  content: '';
  display: block;
  width: 20%;
  margin: 16px 0px;
  border-bottom: solid 4px #2196f3;
}

/* .profile-image-container {
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
} */

/* .profile-image {
  width: 400px;
  height: 400px;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
} */

/* BackgroundDiv.css */
.background-container {
  position: relative;
  display: flex;
}

.background-div {
  /* width: 50%;
  height: 70vh;
  background-image: url("./resources/images/profile/henry-1.png");
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  float: right;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
  box-shadow: inset 40px 0 40px -16px; */
}

.background-div::before {
  /* content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba (255, 255, 255, 0);
  z-index: 0; */
}

.content {
  /* flex: 1;
  position: relative;
  z-index: 1; */
}

/* End Bio */

/* Tasks */

/* Styling for the hover container */
.hover-container {
  position: relative;
  /* width: 200px;
  height: 100px; */
  background-color: #f0f0f0;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  cursor: pointer;
}

/* Styling for the button */
.hover-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

/* Styling for the button when the container is hovered */
.hover-container.hovered .hover-button {
  display: block;
}

/* End Tasks */
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB,uGAAuG;;AAEvG;EACE,kCAAkC;AACpC;;AAEA,WAAW;AACX;;;;;;;;;kEASkE;AAClE;;;;;MAKM;AACN,2CAA2C;AAC3C,MAAM;;AAEN;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY,EAAE,uCAAuC;AACvD;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA,YAAY;;AAEZ,QAAQ;AACR;EACE,QAAQ,EAAE,qBAAqB;EAC/B,UAAU,EAAE,uBAAuB;EACnC,sBAAsB;EACtB,gBAAgB;;EAEhB,sDAAsD;EACtD,mBAAmB;EACnB,cAAc;EACd;;;;;;yCAMuC;EACvC,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;;EAEf,SAAS;;EAET,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA,gBAAgB;;AAEhB,eAAe;;AAEf;EACE,uBAAuB;AACzB;;AAEA,mBAAmB;;AAEnB,UAAU;;AAEV,sBAAsB;AACtB;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB;;;4BAG0B;EAC1B,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,SAAS;EACT,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,8CAA8C;IAC9C,sBAAsB;EACxB;EACA;IACE,2CAA2C;IAC3C,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,cAAc;;AAEd,QAAQ;;AAER;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;GAIG;;AAEH;;;;;;GAMG;;AAEH,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;;;;;;;;;;;wCAWsC;AACxC;;AAEA;EACE;;;;;;;;eAQa;AACf;;AAEA;EACE;;eAEa;AACf;;AAEA,YAAY;;AAEZ,UAAU;;AAEV,oCAAoC;AACpC;EACE,kBAAkB;EAClB;kBACgB;EAChB,yBAAyB;EACzB;;4BAE0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,cAAc;AAChB;;AAEA,cAAc","sourcesContent":["/* index.css or App.css */\r\n/* @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap'); */\r\n\r\nbody {\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\n/* body { */\r\n/* margin: 0;\r\n  padding: 0;\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  background-color: #bdd9f6; Set a background color for the page */\r\n/* background-image: linear-gradient(\r\n    to top right,\r\n    rgb(0, 149, 255),\r\n    rgb(105, 202, 255),\r\n    rgb(232, 247, 255)\r\n  ); */\r\n/* font-family: \"Nunito Sans\" !important; */\r\n/* } */\r\n\r\n.background-image {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 200px;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  z-index: -10; /* Place the image behind the content */\r\n}\r\n\r\n.background-image img {\r\n  width: 50%;\r\n  max-height: 100%;\r\n  border-radius: 300px;\r\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\r\n}\r\n\r\n.overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* BUTTONS */\r\n\r\n/* CSS */\r\n.button-89 {\r\n  --b: 4px; /* border thickness */\r\n  --s: 0.5em; /* size of the corner */\r\n  /* --color: #373b44; */\r\n  --color: #333333;\r\n\r\n  padding: calc(0.5em + var(--s)) calc(0.9em + var(--s));\r\n  color: var(--color);\r\n  --_p: var(--s);\r\n  background: conic-gradient(\r\n      from 90deg at var(--b) var(--b),\r\n      #0000 90deg,\r\n      var(--color) 0\r\n    )\r\n    var(--_p) var(--_p) / calc(100% - var(--b) - 2 * var(--_p))\r\n    calc(100% - var(--b) - 2 * var(--_p));\r\n  transition: 8s linear, color 0s, background-color 1s;\r\n  outline: var(--b) solid #0000;\r\n  outline-offset: 0.6em;\r\n  font-size: 14px;\r\n\r\n  border: 0;\r\n\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n}\r\n\r\n.button-89:hover,\r\n.button-89:focus-visible {\r\n  --_p: 0px;\r\n  outline-color: var(--color);\r\n  outline-offset: 0.05em;\r\n}\r\n\r\n.button-89:active {\r\n  background: var(--color);\r\n  color: #fff;\r\n}\r\n\r\n/* END BUTTONS */\r\n\r\n/* Calculator */\r\n\r\n.calc-input::before {\r\n  border: '3px solid red';\r\n}\r\n\r\n/* End Calculator */\r\n\r\n/* Facts */\r\n\r\n/* @charset \"UTF-8\"; */\r\n.quote {\r\n  width: 100%;\r\n  /* display: inline-block; */\r\n  display: 'flex';\r\n  justify-content: 'center';\r\n  align-items: 'center';\r\n  align-content: 'center';\r\n  margin: '1rem';\r\n  overflow: hidden;\r\n}\r\n.quote blockquote {\r\n  width: 100%;\r\n  height: 155px;\r\n  background-color: #fafafa;\r\n  border: solid 2px #42a5f5;\r\n  border-radius: 4px;\r\n  /* display: \"flex\";\r\n  justify-content: \"center\";\r\n  align-items: \"center\";\r\n  align-content: \"center\"; */\r\n  margin: 0;\r\n  padding: 1em;\r\n  position: relative;\r\n}\r\n.quote blockquote:before {\r\n  background-color: #fff;\r\n  bottom: -10%;\r\n  content: '';\r\n  left: 0;\r\n  position: absolute;\r\n  right: 0;\r\n  top: -10%;\r\n  transform: rotate(-15deg) skew(5deg);\r\n}\r\n.quote blockquote cite {\r\n  display: block;\r\n  font-style: italic;\r\n  text-align: right;\r\n}\r\n.quote blockquote cite:before {\r\n  content: '- ';\r\n}\r\n.quote blockquote > * {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.animated-border-quote {\r\n  display: inline-block;\r\n  margin: 1em;\r\n  max-width: 20em;\r\n  overflow: hidden;\r\n}\r\n.animated-border-quote blockquote {\r\n  background-color: #fff;\r\n  border: solid 2px #757575;\r\n  border-radius: 5px;\r\n  display: inline-block;\r\n  margin: 0;\r\n  padding: 1em;\r\n  position: relative;\r\n}\r\n.animated-border-quote blockquote:before {\r\n  animation: clockwise 30s infinite linear;\r\n  background-color: #fff;\r\n  bottom: 10%;\r\n  content: '';\r\n  left: 0;\r\n  opacity: 0.5;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 10%;\r\n}\r\n.animated-border-quote blockquote:after {\r\n  animation: counter 30s infinite linear;\r\n  background-color: #fff;\r\n  bottom: 10%;\r\n  content: '';\r\n  left: 0;\r\n  opacity: 0.5;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 10%;\r\n}\r\n.animated-border-quote blockquote cite {\r\n  display: block;\r\n  font-style: italic;\r\n  text-align: right;\r\n}\r\n.animated-border-quote blockquote cite:before {\r\n  content: '- ';\r\n}\r\n.animated-border-quote blockquote > * {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n@keyframes clockwise {\r\n  0% {\r\n    transform: rotate(0);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@keyframes counter {\r\n  0% {\r\n    transform: rotate(0);\r\n  }\r\n  100% {\r\n    transform: rotate(-360deg);\r\n  }\r\n}\r\n.animated-shadow-quote {\r\n  display: inline-block;\r\n  margin: 1em;\r\n  max-width: 20em;\r\n  position: relative;\r\n}\r\n.animated-shadow-quote blockquote {\r\n  animation: shadows 2s linear infinite alternate;\r\n  display: inline-block;\r\n  margin: 0;\r\n  padding: 1em;\r\n}\r\n.animated-shadow-quote blockquote cite {\r\n  display: block;\r\n  font-style: italic;\r\n  text-align: right;\r\n}\r\n.animated-shadow-quote blockquote cite:before {\r\n  content: '- ';\r\n}\r\n\r\n@keyframes shadows {\r\n  0% {\r\n    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.25);\r\n    transform: scale(0.95);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.25);\r\n    transform: scale(1);\r\n  }\r\n}\r\n.square-brackets-quote {\r\n  display: inline-block;\r\n  font-family: sans-serif;\r\n  margin: 1em;\r\n  max-width: 20em;\r\n}\r\n.square-brackets-quote blockquote {\r\n  border: solid 1em #ccc;\r\n  border-radius: 5px;\r\n  display: inline-block;\r\n  margin: 0;\r\n  padding: 1em;\r\n  position: relative;\r\n}\r\n.square-brackets-quote blockquote:before {\r\n  background-color: #fff;\r\n  bottom: -1em;\r\n  content: '';\r\n  left: 2em;\r\n  position: absolute;\r\n  right: 2em;\r\n  top: -1em;\r\n}\r\n.square-brackets-quote blockquote cite {\r\n  color: #757575;\r\n  display: block;\r\n  font-size: small;\r\n  font-style: normal;\r\n  text-align: right;\r\n  text-transform: uppercase;\r\n}\r\n.square-brackets-quote blockquote > * {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.giant-quotes-quote {\r\n  display: inline-block;\r\n  font-family: sans-serif;\r\n  margin: 1em;\r\n  max-width: 20em;\r\n}\r\n.giant-quotes-quote blockquote {\r\n  display: inline-block;\r\n  margin: 0;\r\n  padding: 1em;\r\n  position: relative;\r\n}\r\n.giant-quotes-quote blockquote:before {\r\n  color: #f90;\r\n  content: '“';\r\n  font-size: 4em;\r\n  left: 0;\r\n  line-height: 0.75em;\r\n  position: absolute;\r\n  top: 0;\r\n  transform: scale(2, 8);\r\n  transform-origin: top;\r\n}\r\n.giant-quotes-quote blockquote:after {\r\n  color: #f90;\r\n  content: '”';\r\n  font-size: 4em;\r\n  line-height: 0.75em;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  transform: scale(2, 8);\r\n  transform-origin: top;\r\n}\r\n.giant-quotes-quote blockquote > * {\r\n  padding: 0 2em;\r\n}\r\n.giant-quotes-quote blockquote cite {\r\n  color: #c60;\r\n  display: block;\r\n  font-style: normal;\r\n  text-align: right;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* End Facts */\r\n\r\n/* Bio */\r\n\r\n.test::after {\r\n  content: '';\r\n  display: block;\r\n  width: 20%;\r\n  margin: 16px 0px;\r\n  border-bottom: solid 4px #2196f3;\r\n}\r\n\r\n/* .profile-image-container {\r\n  display: inline-block;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n} */\r\n\r\n/* .profile-image {\r\n  width: 400px;\r\n  height: 400px;\r\n  object-fit: cover;\r\n  object-position: center;\r\n  border-radius: 50%;\r\n} */\r\n\r\n/* BackgroundDiv.css */\r\n.background-container {\r\n  position: relative;\r\n  display: flex;\r\n}\r\n\r\n.background-div {\r\n  /* width: 50%;\r\n  height: 70vh;\r\n  background-image: url(\"./resources/images/profile/henry-1.png\");\r\n  background-size: cover;\r\n  background-position: right;\r\n  background-repeat: no-repeat;\r\n  float: right;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: -1;\r\n  box-shadow: inset 40px 0 40px -16px; */\r\n}\r\n\r\n.background-div::before {\r\n  /* content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba (255, 255, 255, 0);\r\n  z-index: 0; */\r\n}\r\n\r\n.content {\r\n  /* flex: 1;\r\n  position: relative;\r\n  z-index: 1; */\r\n}\r\n\r\n/* End Bio */\r\n\r\n/* Tasks */\r\n\r\n/* Styling for the hover container */\r\n.hover-container {\r\n  position: relative;\r\n  /* width: 200px;\r\n  height: 100px; */\r\n  background-color: #f0f0f0;\r\n  /* display: flex;\r\n  align-items: center;\r\n  justify-content: center; */\r\n  cursor: pointer;\r\n}\r\n\r\n/* Styling for the button */\r\n.hover-button {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  padding: 10px 20px;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Styling for the button when the container is hovered */\r\n.hover-container.hovered .hover-button {\r\n  display: block;\r\n}\r\n\r\n/* End Tasks */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
